<template>
  <!-- 头部步骤条 -->
  <div
    v-if="activeKey !== 5"
    class="steps"
    :style="{ backgroundImage: 'url(' + bgUrl + ')', 'margin-top': top + 'px' }"
  >
    <div
      v-for="item in stepData"
      :key="item.key"
      :class="{ s_item: true, s_active: activeKey === item.key }"
      @click="clickTab(item.key)"
    >
      {{ item.name }}
    </div>
  </div>
</template>

<script>
export default {
  props: {
    // margin-top值
    top: {
      type: String,
      default: '10'
    },
    // 当前选中key
    activeKey: {
      type: Number,
      default: 1
    },
    // 背景图名称
    bgurlName: {
      type: String,
      default: ''
    },
    // 步骤数据
    stepData: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    bgUrl() {
      return require(`../../assets/image/common/${this.bgurlName}${this.activeKey}.webp`)
    }
  },
  methods: {
    goBack() {
      this.$router.go(-1)
    },
    clickTab(activeKey) {
      this.$emit('changeActiveKey', activeKey)
    }
  }
}
</script>

<style lang="scss" scoped>
.steps {
  display: flex;
  align-items: center;
  justify-content: space-around;
  height: 40px;
  font-size: 11px;
  font-family: PingFangSC-Medium;
  color: #999;
  background-size: 100% 100%;
  text-size-adjust: none;
  .s_item {
    flex: 1;
  }
  .s_active {
    color: #ffe7a6;
  }
}
</style>
